import React from "react";
import { CommunicationActivity } from "../../../api/services";
import { ActivityListItem } from "./ActivityListItem";
import { CommunicationIcon } from "../../../icons";
import { useCommActivity } from "../hooks/useCommActivity";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const CommActivityItem: React.FC<{
  activity: CommunicationActivity;
}> = ({ activity }) => {
  const { title } = useCommActivity(activity);
  return (
    <ActivityListItem
      icon={<CommunicationIcon width={16} height={16} />}
      title={title}
      activityDttm={activity.activityDttm}
    />
  );
};

export const CommActivitySummaryCell: React.FC<{
  activity: CommunicationActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { title } = useCommActivity(activity);
  return (
    <ActivitySummaryCell
      icon={<CommunicationIcon width={16} height={16} />}
      summary={title}
      isGrey={isGrey}
    />
  );
};
